import React from 'react';
import PriyofyDashboard from '../../components/PriyofyDashboard';

export default function HomeViewPage() {
  return <PriyofyDashboard />;
}
